/*
* 新增广告活动-创意
*/
<template>
  <div class="add-originality">
    <OriginalityCollection v-if="addAdvertisingFormat.adFormat == 0"/>
    <OriginalityVideo v-else-if="addAdvertisingFormat.adFormat == 1" />
  </div>
</template>

<script>
import OriginalityCollection from "./collection/collection"
import OriginalityVideo from "./video/video"
export default {
  name: "add-originality",
  inject: ["getForms"],
  components: { OriginalityCollection, OriginalityVideo },
  data() {
    return {
      addAdvertisingFormat: {}
    }
  },
  created() {
    let { addAdvertisingFormat } = this.getForms()
    this.addAdvertisingFormat = addAdvertisingFormat
  }
};
</script>

<style scoped lang="scss">
.add-originality {
}
</style>